import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-phone',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconPhone {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M16.2 19.63C7.58 19.11.73 12.26.21 3.69c0-1.71 1.34-3.06 3-3.06h4a1 1 0 0 1 .93.63l2 5c.18.46 0 .98-.41 1.23l-1.67 1c.82 1.34 1.96 2.47 3.3 3.3l1-1.67a1 1 0 0 1 1.23-.41l5 2a1 1 0 0 1 .63.93v4c0 1.65-1.35 3-3 3Zm-13-17c-.55 0-1 .45-1 1 .46 7.5 6.5 13.54 14.06 14 .49 0 .94-.45.94-1v-3.32l-3.58-1.43-1.06 1.77c-.27.45-.83.61-1.3.38-2.36-1.16-4.29-3.1-5.45-5.45-.23-.47-.06-1.03.38-1.3l1.77-1.06-1.43-3.58H3.21Z"/>
</svg>

    );
  }
}
